import * as watcherSagas from './watcherSagas'

export { spacesReducer, spaceDetailReducer } from './reducers'
export const spaceWatcherSagas = Object.values(watcherSagas)
export type { SpacesState, SpaceDetailState } from './reducers'
